module.exports = __webpack_public_path__ + "img/arrow.98752cb7.svg";